import { Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';
import { useLocation, useNavigate } from 'react-router-dom';

import { DataGridLoadingOverlay } from './DataGridLoadingOverlay';

interface AppDataGridProps extends DataGridProProps {
  gridHeight?: number | string;
}

export function AppDataGrid({ gridHeight, style, ...props }: AppDataGridProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const basePath = pathname.replace(/\/$/, '');
  const resolvedGridHeight = gridHeight ?? (style?.flexGrow ? '100%' : 600);
  return (
    <Paper sx={props.sx}>
      <DataGridPro
        onRowClick={({ id }) => navigate(`${basePath}/${id}`)}
        {...props}
        style={{ height: resolvedGridHeight, ...style }}
        sx={[
          {
            '& .MuiDataGrid-columnHeader--filtered .MuiDataGrid-iconButtonContainer': {
              visibility: 'visible',
            },
            '& .MuiDataGrid-columnHeader--filtered .MuiDataGrid-iconButtonContainer .MuiIconButton-root':
              {
                color: 'secondary.main',
                backgroundColor: theme => alpha(theme.palette.primary.main, 0.14),
              },
            '& .MuiDataGrid-columnHeader--filtered .MuiDataGrid-iconButtonContainer .MuiIconButton-root:hover':
              {
                backgroundColor: theme => alpha(theme.palette.secondary.main, 0.22),
              },
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
        slots={{ loadingOverlay: DataGridLoadingOverlay, ...props.slots }}
      />
    </Paper>
  );
}
